import { render, staticRenderFns } from "./InfoIconWrapper.vue?vue&type=template&id=479c68cf&scoped=true&"
import script from "./InfoIconWrapper.vue?vue&type=script&lang=ts&"
export * from "./InfoIconWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./InfoIconWrapper.vue?vue&type=style&index=0&id=479c68cf&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479c68cf",
  null
  
)

export default component.exports